import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["AI Tools", "ИИ-инструменты"][index],
        placeholder: ["Name, Description", "Название, Описание"][index],
        addLabel: ["Add AI Tool", "Добавить ИИ-инструмент"][index],
        validationMessage: [
            "Both Name and Description must be filled",
            "Название и описание должны быть заполнены",
        ][index],
    };
};
